import React from 'react';
import { IStandingsMatch } from 'twain-sport-fe-mono/interfaces';
import { contextFactory } from 'twain-sport-fe-mono/utils/contextFactory';

interface IRenderStandingMatchStatus {
    match: IStandingsMatch;
}

interface IStandingsContext {
    Link: React.FC<React.PropsWithChildren<{ to: string; className: string }>>;
    getMatchUrl(matchCode?: string): string;
    getMatchVideoUrl?(matchCode: string): string;
    getBetUrl?(matchCode: string): string;
    renderMatchStatus?(props: IRenderStandingMatchStatus): JSX.Element;
}

const [useStandingsContext, StandingsContext] = contextFactory<IStandingsContext>();

export { useStandingsContext };

export const StandingsContextProvider: React.FC<React.PropsWithChildren<IStandingsContext>> = (
    props,
) => {
    const contextValue = React.useMemo<IStandingsContext>(
        () => ({ ...props }),
        [
            props.Link,
            props.getMatchVideoUrl,
            props.getMatchUrl,
            props.getBetUrl,
            props.renderMatchStatus,
        ],
    );

    return (
        <StandingsContext.Provider value={contextValue}>{props.children}</StandingsContext.Provider>
    );
};
